import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: Number, duration: Number };
  connect() {
    this.element.style["animation-delay"] = `${this.delayValue}ms`;
    this.onSlideAnimationEndBind = this.#onSlideAnimationEnd.bind(this);
    this.element.addEventListener("animationend", this.onSlideAnimationEndBind);
    this.element.classList.add("animate-slide-down");
  }

  close() {
    // Remove initial animation listener
    this.element.removeEventListener(
      "animationend",
      this.onSlideAnimationEndBind,
    );
    this.element.classList.remove("animate-slide-down");
    this.element.style.opacity = null;
    this.element.style["animation-delay"] = null;

    // Add new event listener
    this.element.addEventListener("animationend", () => {
      this.element.remove();
    });
    this.element.classList.add("animate-fade-out", "animation-forwards");
  }

  #onSlideAnimationEnd() {
    setTimeout(() => {
      this.close();
    }, this.durationValue);
  }
}
